import * as brands from './brand/index.js';
import * as catalog from './catalog/index.js';
import * as productCard from './product-card/index.js';

catalog.init();
brands.init();
productCard.init();